import { S, Icon } from '../regureStyles';

const TransfersTab = () => {
  return (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 10, padding: 32, textAlign: 'center' }}>
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 12,
          background: `${S.info}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <Icon name='globe' size={24} color={S.info} />
      </div>
      <div style={{ fontWeight: 600, fontSize: 16, color: S.textPrimary, marginBottom: 8 }}>No Cross-Border Transfers</div>
      <div style={{ color: S.textMuted, fontSize: 14, maxWidth: 400, margin: '0 auto' }}>
        All data processing occurs within Switzerland. No cross-border data transfers are currently configured, maintaining full FADP compliance.
      </div>
    </div>
  );
};

export default TransfersTab;
